import { render, staticRenderFns } from "./CalculatorPersonalGainQuickstartBonus.vue?vue&type=template&id=f5398f3e&scoped=true"
import script from "./CalculatorPersonalGainQuickstartBonus.vue?vue&type=script&lang=js"
export * from "./CalculatorPersonalGainQuickstartBonus.vue?vue&type=script&lang=js"
import style0 from "./CalculatorPersonalGainQuickstartBonus.vue?vue&type=style&index=0&id=f5398f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5398f3e",
  null
  
)

export default component.exports